import "./CustomConnectButton.scss";
import { useAppKit } from "@reown/appkit/react";
import { useAccount, useChainId } from "wagmi";
import { useEffect, useMemo } from "react";

export const CustomConnectButton = () => {
  const { open } = useAppKit();
  const { address, isConnected, chain, isConnecting } = useAccount();
  const chainId = useChainId();
  const goodChainSelected = useMemo(
    () => chainId === chain?.id,
    [chainId, chain]
  );

  useEffect(() => {
    if (isConnecting) {
      return;
    }

    try {
      const btn = document.querySelector("#connectbutton") as HTMLButtonElement;
      btn.click();
    } catch (error) {
      return;
    }

    return () => {
      try {
        const allButtons = document.querySelectorAll("button");
        const closeButton = Array.from(allButtons).find(
          (button) => button.getAttribute("aria-label") === "Close"
        ) as HTMLButtonElement;
        closeButton.click();
      } catch (error) {
        return;
      }
    };
  }, [isConnecting]);

  if (isConnecting) {
    return <div>Connecting...</div>;
  }

  if (!isConnected) {
    return (
      <div
        style={{ display: "flex", gap: 12 }}
        className="custom-connect-button"
      >
        <button
          onClick={() => open()}
          type="button"
          id="connectbutton"
          className="custom-connect-button"
        >
          Connect Wallet
        </button>
      </div>
    );
  }

  if (!goodChainSelected) {
    return (
      <div
        style={{ display: "flex", gap: 12 }}
        className="custom-connect-button"
      >
        <button
          onClick={() => open()}
          type="button"
          className="custom-connect-button"
        >
          Please select a supported chain
        </button>{" "}
      </div>
    );
  }

  return (
    <div style={{ display: "flex", gap: 12 }} className="custom-connect-button">
      <button
        onClick={() => open()}
        style={{ display: "flex", alignItems: "center" }}
        type="button"
      >
        {chain?.name}
      </button>
      <button onClick={() => open()} type="button">
        {address ? `${address.slice(0, 6)}...${address.slice(-4)}` : ""}
      </button>
    </div>
  );
};
